import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import DraggableModal from "../../layout/DraggableModal/DraggableModal";
import { CORE_FEATS } from "../../../catalogs/featsCatalog";

const FeatPickerModal = ({ isOpen, onClose, selectedFeats, onSelect }) => {
  const { i18n, t } = useTranslation();
  const [search, setSearch] = useState("");
  const selectedCatalogIds = new Set(selectedFeats.map((feat) => feat.catalogId || feat.id));
  const language = (i18n.resolvedLanguage || i18n.language) === "en" ? "en" : "ru";
  const alternateLanguage = language === "en" ? "ru" : "en";
  const feats = useMemo(
    () => CORE_FEATS
      .filter((feat) => `${feat.name.ru} ${feat.name.en}`.toLowerCase().includes(search.toLowerCase()))
      .sort((left, right) => left.name[language].localeCompare(right.name[language], language)),
    [language, search]
  );

  return isOpen && (
    <DraggableModal isVisible={isOpen} onClose={onClose} headerText={t("sheet.chooseFeat")}>
      <label className="feat-search">{t("sheet.searchFeats")}<input value={search} onChange={(event) => setSearch(event.target.value)} placeholder={t("sheet.featPlaceholder")} /></label>
      <div className="feat-catalog-list">
        {feats.map((feat) => (
          <button key={feat.id} type="button" className="feat-catalog-item" disabled={selectedCatalogIds.has(feat.id)} onClick={() => onSelect(feat)}>
            <strong>{feat.name[language]}</strong><small>{feat.name[alternateLanguage]}</small><span>{feat.category[language]}</span><small>{t("sheet.prerequisites")}: {feat.prerequisites[language]}</small><small>{feat.description[language]}</small>
          </button>
        ))}
      </div>
    </DraggableModal>
  );
};

export default FeatPickerModal;
